import React, {Component} from "react";
import "./Pou.css"
import Button from "react-bootstrap/Button";
import dataPou from "../../data/dataPou.json";
import ChoiceButton from "../ChoiceRayon/ChoiceButton";


const data = dataPou;


export default class Okup extends Component {


    constructor(props) {
        super(props);

        //console.log(idn)
        this.state = {
            pou: data,
            pou0: data,
            show: true
        };


    }


    choiceBackRayon = () => {
        const data0 = this.state.pou0;
        this.setState({
            pou: data0,
            show: false
        });

    }

    render() {
        const rayon = this.state.show;
        return (
            rayon ?
                <div className="col-auto flex-grow-1"><Button className="btn " onClick={this.choiceBackRayon} style={{
                    width: "auto",
                    height: "auto",
                    marginTop: "-3rem",
                    marginBottom: "3rem"
                }}> Повернутися до вибору району </Button>
                    <div><span style={{marginLeft: "25%"}}>Дані відсутні.Тимчасово непідконтрольна територія. </span>
                    </div>
                </div> :
                <ChoiceButton/>
        );
    }
}
